<div class="page-container profile-history-container container pt-3">
  <h1 class="header col-12 mb-2">
    Case History

    <span>
      <button
        type="button"
        class="me-2"
        mat-raised-button
        color="primary"
        (click)="legacyView()"
      >
        <mat-icon>history_edu</mat-icon>Legacy View
      </button>
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="dlXlsx()"
      >
        <mat-icon>cloud_download</mat-icon>Download Excel File
      </button>
    </span>
  </h1>

  <div class="profile-history-summary-container row py-2 px-3 mb-2">
    <div class="profile-history-data-container px-0 pb-1">
      <div class="profile-history-summary-header">
        Case Number: <span class="summary-number ms-2">{{ caseNumber }}</span>
      </div>

      <div class="row px-3 pt-2">
        <span class="col-3 mb-2">
          <div class="data-label">Solution</div>
          <span class="data-value">
            {{ solutionName }}
          </span>
        </span>
        <span class="col-3 mb-2">
          <div class="data-label">ProfileID</div>
          <span class="data-value">
            {{ profileId }}
          </span>
        </span>
        <span class="col-3 mb-2">
          <div class="data-label">Client Name</div>
          <span class="data-value">
            {{ clientName }}
          </span>
        </span>
        <span class="col-3 mb-2">
          <div class="data-label">User Name</div>
          <span class="data-value">
            {{ userName }}
          </span>
        </span>
        <span class="col-3 mb-2">
          <div class="data-label">RepCode</div>
          <span class="data-value">
            {{ repCode }}
          </span>
        </span>
        <span class="col-3 mb-2">
          <div class="data-label">Runs</div>
          <span class="data-value">
            {{ runs || 0 }}
          </span>
        </span>
        <span class="col-3 mb-2">
          <div class="data-label">
            Score Class Change{{ scoreClassChanges > 1 ? 's' : '' }}
          </div>
          <span class="data-value">
            {{ scoreClassChanges || 0 }}
          </span>
        </span>
      </div>
    </div>
  </div>

  @if (productTypes) {
    <div class="profile-history-card">
      <div class="profile-history-header">
        <span class="cell-selection-actions">
          Case Runs
          <mat-icon
            class="ms-2 help-icon"
            matTooltip="Click on multiple tiles to select them for comparison"
          >
            help
          </mat-icon>
        </span>
        <div class="cell-selection-actions">
          <button
            type="button"
            class="me-3"
            mat-button
            color="warn"
            [disabled]="!selectedChanges.length"
            (click)="resetSelectedChanges()"
          >
            <mat-icon>replay</mat-icon> Reset
          </button>

          <button
            type="button"
            mat-raised-button
            [disabled]="!selectedChanges.length"
            (click)="openChangeDetails()"
          >
            <mat-icon>compare_arrows</mat-icon> Compare Changes
            @if (selectedChanges.length) {
              ({{ selectedChanges.length }})
            }
          </button>
        </div>
      </div>

      <div class="profile-history-grid-container" id="grid-container">
        <table #profileHistoryGrid>
          <thead>
            <th class="empty-sticky-cell"></th>
            <th class="empty-sticky-cell product-cell"></th>
            @for (
              changeCount of dataColumns;
              track changeCount;
              let i = $index
            ) {
              <th class="change-stats-container">
                <div class="change-count"> Run {{ i + 1 }} </div>
                <div class="change-date">
                  {{ changeCount.date }}
                </div>
              </th>
            }
          </thead>
          <tbody>
            @for (product of productTypes; track product.label) {
              <tr class="product-row">
                <td class="product-label-cell">
                  <div class="product-label-container">
                    <div class="product-label">
                      {{ product.label.toUpperCase() || 'OTHER' }}
                    </div>
                  </div>
                </td>
                <td class="bridge-name-cell">
                  @for (bridge of product.Bridges; track bridge.productName) {
                    <tr>
                      <td class="product-name-contasiner">
                        <div
                          matTooltip="{{
                            bridge.productName
                          }} (Click to select row)"
                          class="bridge-name-container {{
                            isBridgeSelectable(bridge) ? '' : 'not-selectable'
                          }}"
                          matTooltipShowDelay="1000"
                          (click)="selectFullRow(bridge)"
                        >
                          @if (isExchange(bridge)) {
                            <mat-icon class="exchange-indicator">
                              swap_vertical_circle
                            </mat-icon>
                          }

                          {{ bridge.productName }}
                        </div>
                      </td>
                    </tr>
                  }
                </td>
                @for (
                  changeCount of dataColumns;
                  track changeCount.profileChangeID
                ) {
                  <td>
                    @for (bridge of product.Bridges; track bridge) {
                      <tr
                        class="bridge-row {{
                          isBridgeSelectable(bridge) ? '' : 'not-selectable'
                        }}"
                      >
                        <td class="change-column">
                          @if (
                            bridgeHasChanges(
                              bridge,
                              changeCount.profileChangeID
                            )
                          ) {
                            <div
                              class="change text-center {{
                                selectedChanges.includes(
                                  changeCount.profileChangeID
                                ) && isBridgeSelectable(bridge)
                                  ? 'selected'
                                  : ''
                              }}"
                              matTooltipShowDelay="1000"
                              [matTooltip]="
                                getChangeAmount(
                                  bridge,
                                  changeCount.profileChangeID
                                ) !== '00'
                                  ? 'Click to select change'
                                  : ''
                              "
                              [ngClass]="
                                getChangeClass(
                                  bridge,
                                  changeCount.profileChangeID
                                )
                              "
                              (click)="
                                isBridgeSelectable(bridge) &&
                                getChangeAmount(
                                  bridge,
                                  changeCount.profileChangeID
                                ) !== '00'
                                  ? toggleChangeSelection(
                                      bridge,
                                      changeCount.profileChangeID
                                    )
                                  : null
                              "
                            >
                              @switch (
                                getChangeClass(
                                  bridge,
                                  changeCount.profileChangeID
                                )
                              ) {
                                @case ('positive') {
                                  <mat-icon class="positive me-1">
                                    check_circle
                                  </mat-icon>
                                }
                                @case ('neutral') {
                                  <mat-icon class="neutral me-1">
                                    error
                                  </mat-icon>
                                }
                                @case ('negative') {
                                  <mat-icon class="negative me-1">
                                    remove_circle
                                  </mat-icon>
                                }
                                @case ('no-class') {
                                  <mat-icon class="negative me-1">
                                    pending
                                  </mat-icon>
                                }
                              }
                              {{
                                getChangeAmount(
                                  bridge,
                                  changeCount.profileChangeID
                                ) | currency
                              }}
                            </div>
                          } @else {
                            <div class="change empty-change"> -- </div>
                          }
                        </td>
                      </tr>
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <div class="exchange-key mt-2">
      <mat-icon> swap_vertical_circle </mat-icon> = Existing Product
    </div>
  }
  <ngx-loading [show]="loading" />
</div>
